import { equals } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { GranteeTypeEnum } from '@fasstech/oip-core/entities/Grantee/enums';

const useGranteeForm = ({ index }) => {
  const form = useFormContext();

  const grantees = form.watch('grantees');

  const granteeType = form.watch(`grantees.${index}.type`);

  const granteeIsChild = equals(granteeType, GranteeTypeEnum.CHILD);
  const granteeIsSpouse = equals(granteeType, GranteeTypeEnum.SPOUSE);

  const getFieldsName = (name) => `grantees.${index}.${name}`;

  const id = form.watch(`grantees.${index}.id`);

  return {
    id,
    getFieldsName,
    form,
    grantees,
    granteeType,
    granteeIsChild,
    granteeIsSpouse
  };
};

export default useGranteeForm;
